import { Location } from "@/interfaces/location";
import { Stems } from "@/interfaces/stems";
import { i18n } from "@/plugins/i18n";
import {
  FormField,
  FormFieldTypes,
  FormLateralGroup
} from "helix-vue-components";

export const stemsForm: FormField[] = [
  {
    label: i18n.t("stems.email"),
    component: FormFieldTypes.textField,
    name: "email",
    options: {
      validationRules: ["required", "email"],
      row: 1,
      flex: 12
    }
  },
  {
    label: i18n.t("stems.confirmBeforeSending"),
    component: FormFieldTypes.checkbox,
    name: "apiCallOptions.confirmBeforeSending",
    options: {
      group: FormLateralGroup.right,
      checkboxTitle: String(i18n.t("stems.apiCallOptions"))
    }
  },
  {
    label: i18n.t("stems.confirmDetaislBeforeSending"),
    component: FormFieldTypes.checkbox,
    name: "apiCallOptions.confirmDetaislBeforeSending",
    options: {
      group: FormLateralGroup.right
    }
  },
  {
    label: i18n.t("stems.reviewDetailsAfterSending"),
    component: FormFieldTypes.checkbox,
    name: "apiCallOptions.reviewDetailsAfterSending",
    options: {
      group: FormLateralGroup.right
    }
  },
  {
    label: i18n.t("stems.password"),
    component: FormFieldTypes.textField,
    name: "password",
    options: {
      validationRules: ["required"],
      row: 2,
      flex: 12
    }
  },
  {
    label: i18n.t("stems.ubiNumber"),
    component: FormFieldTypes.textField,
    name: "ubiNumber",
    options: {
      validationRules: ["required"],
      row: 3,
      flex: 12
    }
  },
  {
    label: i18n.t("stems.url"),
    component: FormFieldTypes.textField,
    name: "url",
    options: {
      validationRules: ["required"],
      row: 4,
      flex: 12
    }
  },
  {
    label: i18n.t("stems.zeroSum"),
    component: FormFieldTypes.checkbox,
    name: "miscSettings.zeroSum",
    options: {
      group: FormLateralGroup.right,
      checkboxTitle: String(i18n.t("stems.miscSettings"))
    }
  },
  {
    label: i18n.t("stems.autoCorrect"),
    component: FormFieldTypes.checkbox,
    name: "miscSettings.autoCorrect",
    options: {
      group: FormLateralGroup.right
    }
  },
  {
    label: i18n.t("stems.startingInventoryDate"),
    component: FormFieldTypes.datepicker,
    name: "startingInventoryDate",
    options: {
      validationRules: ["required"],
      pickerOptions: {
        required: true,
        "value-format": "yyyy-MM-dd"
      },
      row: 5,
      flex: 12
    }
  },
  {
    label: i18n.t("stems.retryCount"),
    component: FormFieldTypes.textField,
    name: "retryCount",
    options: {
      validationRules: ["required"],
      row: 6,
      flex: 12
    }
  },
  {
    label: i18n.t("stems.timeout"),
    component: FormFieldTypes.textField,
    name: "timeout",
    options: {
      validationRules: ["required"],
      row: 7,
      flex: 12
    }
  }
];

export const StemsMock: Stems[] = [
  {
    id: 1,
    apiCallOptions: {
      confirmBeforeSending: true,
      confirmDetailsBeforeSending: true,
      reviewApiDetailsAfterSending: true
    },
    miscSettings: {
      autoCorrect: false,
      zeroSum: true
    },
    email: "something@gmail.com",
    enabled: false,
    password: "password",
    retryCount: 10,
    startingInventoryDate: "",
    timeout: 1000,
    ubiNumber: "029305491",
    url: "https://google.com"
  },
  {
    id: 2,
    apiCallOptions: {
      confirmBeforeSending: true,
      confirmDetailsBeforeSending: true,
      reviewApiDetailsAfterSending: true
    },
    miscSettings: {
      autoCorrect: false,
      zeroSum: true
    },
    email: "something@gmail.com",
    enabled: true,
    password: "password",
    retryCount: 10,
    startingInventoryDate: "",
    timeout: 1000,
    ubiNumber: "029305491",
    url: "https://other.com"
  },
  {
    id: 3,
    apiCallOptions: {
      confirmBeforeSending: true,
      confirmDetailsBeforeSending: true,
      reviewApiDetailsAfterSending: true
    },
    miscSettings: {
      autoCorrect: false,
      zeroSum: true
    },
    email: "something@gmail.com",
    enabled: false,
    password: "password",
    retryCount: 10,
    startingInventoryDate: "",
    timeout: 1000,
    ubiNumber: "029305491",
    url: "https://google.com"
  },
  {
    id: 4,
    apiCallOptions: {
      confirmBeforeSending: true,
      confirmDetailsBeforeSending: true,
      reviewApiDetailsAfterSending: true
    },
    miscSettings: {
      autoCorrect: false,
      zeroSum: true
    },
    email: "sarasasa@gmail.com",
    enabled: true,
    password: "password",
    retryCount: 10,
    startingInventoryDate: "",
    timeout: 1000,
    ubiNumber: "029305491",
    url: "https://google.com"
  },
  {
    id: 5,
    apiCallOptions: {
      confirmBeforeSending: true,
      confirmDetailsBeforeSending: true,
      reviewApiDetailsAfterSending: true
    },
    miscSettings: {
      autoCorrect: false,
      zeroSum: true
    },
    email: "sarasasa@gmail.com",
    enabled: true,
    password: "password",
    retryCount: 10,
    startingInventoryDate: "",
    timeout: 1000,
    ubiNumber: "029305491",
    url: "https://google.com"
  },
  {
    id: 6,
    apiCallOptions: {
      confirmBeforeSending: true,
      confirmDetailsBeforeSending: true,
      reviewApiDetailsAfterSending: true
    },
    miscSettings: {
      autoCorrect: false,
      zeroSum: true
    },
    email: "sarasasa@gmail.com",
    enabled: true,
    password: "password",
    retryCount: 10,
    startingInventoryDate: "",
    timeout: 1000,
    ubiNumber: "029305491",
    url: "https://google.com"
  }
];

export const StemsLocations: Array<Partial<Location>> = [
  { name: "Bulldog (Texas)", id: 1 },
  { name: "Your Place", id: 2 },
  { name: "Bulldog", id: 3 },
  { name: "1160 Mertz Cove", id: 4 },
  { name: "Green Store", id: 5 },
  { name: "1154 Tremblay Square Suite 318", id: 6 }
];
